const axios = require('axios');
const BACK_API_URL = '/coreService';
const AUTH_URI = '/moduleCore/auth/login';

export const login = (data, fnSuccess, fnError = () => {}) => {
	let config = {
		method: 'post',
		maxBodyLength: Infinity,
		url: BACK_API_URL + AUTH_URI,
		headers: {
			'Content-Type': 'application/json',
		},
		withCredentials: true,
		data: JSON.stringify(data),
	};

	axios
		.request(config)
		.then((response) => {
			fnSuccess(response.data);
		})
		.catch((error) => {
			const message =
				error.response?.data?.error?.message ||
				error.response?.data?.message ||
				error.message ||
				'Unknown error occurred';
			fnError(message);
		});
};
